module.exports = __webpack_public_path__ + "static/media/Hand-Me-Down.c7609837.gif";